module.exports = "/images/vendor/flag-icon-css/flags/4x3/ly.svg?d089645e2ba9f431431b479cc902bf43";